import { config } from "zod/v4/core";
import { startSplash } from "./splash.ts";
import "@sewnique/ui/styles.css";



// The page's entry. Zod 4 compiles fast object parsers with `new Function` when it can, probing for it as schemas are
// built. The CSP allows no eval (script-src 'self' and 'wasm-unsafe-eval' for the code reader's WebAssembly, E4.8), so the probe would be blocked and reported on every start.
// Jitless parsing is the documented switch (same results, no eval), and it has to be set before any module builds a
// schema: hence here, with the app loaded after it. The stylesheet is imported here too, so it is linked in <head> and
// paints with the page: theme-init.js picks the theme before the first frame, and the colours must be there to show it.
config({ jitless: true });

// In this first small chunk, so the thread is drawing while the app loads.
if (import.meta.env.MODE === "production") {
  void startSplash();
}

void import("./main.tsx");
